import React from 'react';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';

import ApiUiController from '../../controller/ApiUiController';
import Util from '../../util/Util';
import ColdDataApi from '../../api/ColdDataApi';

class CampaignRenamePopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inApiCall: false,
      campaignName: props.name,
    };
  }

  onSubmit = () => {
    const { campaignName } = this.state;
    if (!campaignName || !campaignName?.trim() || !this.props.id) {
      Util.showNotification('Error', 'Please fill all fields', 'danger');
      return;
    }
    this.setState({ inApiCall: true });
    ColdDataApi.renameCampaign(this.props.id, { name: campaignName.trim() }, this.onSuccess, this.onFail);
  };

  onSuccess = (res) => {
    this.setState({ inApiCall: false });
    Util.showNotification('Success', 'Campaign renamed', 'success');
    this.setState({ campaignName: "" });
    this.props.onRename(this.props.id, res?.name);
  };

  onFail = (res) => {
    this.setState({ inApiCall: false }); 
    console.log("errror", res);
    Util.showNotification('Failed', res?.message || 'Something went wrong', 'danger');
    this.onHide();
  };

  onHide = () => {
    this.setState({ campaignName: "", inApiCall: false });
    this.props.onHide();
  }

  render() {  
    return (
      <Modal show={this.props.show} onHide={() => this.onHide()} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Rename Campaign</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <ApiUiController inApiCall={this.state.inApiCall}>
              <div className="form-group">
                <label>Campaign Name</label>
                <FormControl
                  type="text"
                  placeholder="Enter campaign name"
                  defaultValue={this.props.name}
                  onChange={(e) => this.setState({ campaignName: e.target.value })}
                />
              </div>
            </ApiUiController>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.onHide}>Cancel</Button>
          <Button variant="primary" onClick={this.onSubmit}>Submit</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CampaignRenamePopup;
